module.exports = __webpack_public_path__ + "media/images/emblems/Russin-coat_of_arms-d912d9edee830a5a3ded9c96bcf31ccf.svg";